import { Http, Headers } from '@angular/http';
import { Injectable } from '@angular/core';
import { ApiBaseService } from './api-base.service';
import { StateService } from './../state.service';
import { AlertService } from './../alert.service';
import { ToastService } from './../toast.service';
import { App, Events, Platform, LoadingController, ToastController } from "ionic-angular";
import { ApiAuthStore } from '../store/api.auth.store';
import { UtilService } from '../util.service';

@Injectable()
export class ApiSleepService extends ApiBaseService {

  protected headers: Headers;
  protected apiName = '[ ApiSleepService ]';
  isLoading: boolean = true;

  constructor(
    protected app: App,
    protected events: Events,
    protected http: Http,
    public plt: Platform,
    protected stateService: StateService,
    protected alertService: AlertService,
    protected toastService: ToastService,
    protected loadingCtrl: LoadingController,
    protected toastController: ToastController,
    protected apiAuthStore: ApiAuthStore,
    public utilService: UtilService,
  ) {
    super(app, events, http, plt, stateService, alertService, toastService, loadingCtrl, toastController, apiAuthStore, utilService);
  }
  /**
   * 登録処理
   * @param params 
   */
  post(params): Promise<any> {
    return new Promise((resolve) => {
      return this.doPost({
        url: this.apiAuthStore.url + '/api/v1/sleep/info',
        body: params, headers: this.headers
      }).subscribe(response => resolve(response))
    })
  }

  /**
   * 更新処理
   * @param params 
   */
  put(params): Promise<any> {
    return new Promise((resolve) => {
      return this.doPut({
        url: this.apiAuthStore.url + '/api/v1/sleep/info',
        body: params, headers: this.headers
      }).subscribe(response => resolve(response))
    })
  }

  getStateList(targetDate = null): Promise<any> {
    let url = this.apiAuthStore.url + '/api/v1/sleep/stateList';
    if (targetDate) {
      url += `?targetDate=${targetDate}`
    }
    return new Promise((resolve) => {
      return this.doGet({
        url: url,
        body: {}, headers: this.headers}
      ).finally(() => this.isLoading = false
      ).subscribe(response => resolve(response))
    });
  }

  getStateDetail(params): Promise<any> {
    let url = this.apiAuthStore.url + `/api/v1/sleep/stateDetail?patientId=${params.patientId}`;
    if (params.targetMonth) {
      url += `&targetMonth=${params.targetMonth}`
    }
    return new Promise((resolve) => {
      return this.doGet({
        url: url,
        body: {}, headers: this.headers}
      ).finally(() => this.isLoading = false
      ).subscribe(response => resolve(response))
    });
  }

}



// WEBPACK FOOTER //
// ./src/providers/api-call-providers/api-sleep.service.ts